export default __webpack_public_path__ + "static/media/profile.d0017895.jpg";